export function getAddress(address, strict) {

    const searchService = process.env.REACT_APP_MAR_SERVICE; 
    const searchToken = process.env.REACT_APP_MAR_KEY;
    const promise = new Promise((resolve, reject) => {
      let url = searchService;
      if (strict) {
        url += 'locations?' + searchToken;
      } else {
        url += 'autocomplete?' + searchToken;
      }
      // fetch mar 2 data
      fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({address: address.toLowerCase() })
      })
      .then(
          res => {
            return res.json();
          },
          () => reject('An unexpected problem occured')
      )
      .then(data => {
          if (!data) {
            reject('No results...');
          } else {
            if (Array.isArray(data.Result.addresses) && strict) {
              let matchAddress = null;
              data.Result.addresses.forEach(dataObj => {
                let addrString = dataObj.address.properties.FullAddress || "";
                let aliasString = dataObj.address.properties.Alias || "";
                if (addrString.toUpperCase() === address.toUpperCase() || aliasString.toUpperCase() === address.toUpperCase()) {
                  matchAddress = dataObj;
                }
              });
              resolve(matchAddress);
            } else if (Array.isArray(data.Result) && !strict) {
                let formatedArray = data.Result.map(add => {
                    return dcAddressToTitleCase(add);
                })
                resolve(formatedArray);
            } else {
              reject('No results');
            }
          }
        });
    });
    return promise;
}

// returns an upper or lower case address to type case with handling for suffix
export function dcAddressToTitleCase(str) {
    let strArr = str.toLowerCase().split(' ');
    strArr.forEach((strPiece, index) => {
        switch (strPiece.toLowerCase()) {
            case 'se':
            case 'sw':
            case 'ne':
            case 'nw':
            case 'dc':
                // if suffix, convert to UPPER CASE
                strArr[index] = strPiece.toUpperCase();
                break;
            default:
                // else camel case
                strArr[index] = strPiece.charAt(0).toUpperCase() + strPiece.slice(1);
        }
    });
    return strArr.join(' ');
}